import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { environment } from '@/app/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-uploaded-attachments',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './uploaded-attachments.component.html',
  styleUrl: './uploaded-attachments.component.css'
})
export class UploadedAttachmentsComponent {
  @Input() label: string = 'Attachments';
  @Input() attachments: any[] = [];
  @Input() projectId: number;
  @Input() modelType: string;
  @Input() modelId: number;

  docUrl: string | null = null;

  constructor(
    private http: HttpClient,
  ) { }

  downloadDocument(
    event: Event,
    downloadLink: HTMLAnchorElement,
    id: number,
    filePath: string
  ): void {
    event.preventDefault();

    const parts = filePath.split('/');
    const _filePath = parts[parts.length - 1];

    const apiUrl = environment.apiUrl;
    const fullPath = `${apiUrl}/projects/${this.projectId}/${this.modelType}/${this.modelId}/documents/${id}/${_filePath}/download`;

    // Fetch the image from the backend
    this.http.post(fullPath, {}, { responseType: 'blob' }).subscribe((blob) => {
      const docUrl = window.URL.createObjectURL(blob); // Create a blob URL
      downloadLink.href = docUrl; // Set the href to the blob URL
      downloadLink.click(); // Trigger the download

      // Clean up the blob URL after use
      window.URL.revokeObjectURL(docUrl);
    });
  }
}
